import React from "react";
import SarasChip from "../../repeater/list/SarasChip";

const FormTag = (props) => {
    const { formObject, rowKey,headerKey, action, disableDelete } = props;
    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);

    const deleteTag = () => {
        action["actionId"] = 'del';
        formObject.onFormAction(action, rowKey, headerKey);
    }

    // console.log("viewdata disableDelete", disableDelete);

    if(!viewData)
        return(null)

    return (
        <li>
            <SarasChip
              size="small"
              data={{val : viewData.valF, key: rowKey || headerKey}}
              onClick={undefined}
              onDelete={disableDelete ? undefined : deleteTag}
            />
        </li>
    )
}

export default FormTag